import {History} from '../../../graphql-typings/graphql';
import {SimpleFunction} from './simple-function';
import {FunctionName} from './chart-function-types';

export class FloorFunction extends SimpleFunction {

  constructor() {
    super(FunctionName.FLR, 'Floor');
  }

  run(historyArray: History[]): History[] {
    return super.applySimpleFunction(Math.floor, historyArray);
  }
}
